<template>
    <div :style="{ width: boxWidth, ...wrapStyle }">
        <ul class="el-upload-list el-upload-list--text" v-for="(item, index) in filelist" :key="index">
            <li tabindex="0" class="el-upload-list__item "><!----><a class="el-upload-list__item-name"><i
                        class="el-icon-document"></i>{{ item.name }}
                </a>
                <div class="el-upload-list__item-status-down"><span class="preview" v-if="item.filetype !== '其他'"
                        style="margin: 5px;" @click="openPreview(item, item.url)">预览</span><span class="download"
                        @click="downloadFile(item.name, item.url)">下载</span></div>
            </li>
            <!--<label class="el-upload-list__item-status-down"
                    @click="downloadFile(item.name, item.url)">预览 下载</label>-->
        </ul>
        <viewer :images="images" :index="0" ref="viewer">
            <img v-for="(image, index) in images" :key="index" style="display: none;" :src="image" />
        </viewer>
    </div>

</template>

<script>
import VideoDPlayer from './VideoDPlayer'
import AudioDPlayer from './AudioDPlayer'
export default {
    name: 'BaseFilelist',
    inheritAttrs: false,
    props: {
        filelist: {
            type: Array,
            default: () => []
        },
        width: [String, Number],
        gutter: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            dialogLoading: '',
            CHUNK_SIZE: 10 * 1024 * 1024,
            images: [],
            playerOptions: {
                video: {
                    url: ''
                },
                autoplay: true,
                preload: 'auto',
                volume: 0.7,
                screenshot: true,
                airplay: true,
                hotkey: true,
                theme: '#FADFA3',
                loop: true,
                lang: 'zh-cn',
                mutex: true,
                // 在这里设置 DPlayer 的配置选项
            }
        }
    },
    methods: {
        async downloadFile(fileName, fileUrl) {

            this.dialogLoading = this.$loading({
                lock: true,
                text: '下载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            let that = this;
            fetch(fileUrl).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
                const a = document.createElement('a')
                a.href = URL.createObjectURL(blob)
                a.download = fileName
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a);
                that.dialogLoading && this.dialogLoading.close()
            })
        },
        async openPreview(item, fileUrl) {
            this.images = []
            if (item.filetype === 'image') {


                this.images.push(fileUrl)
                const viewer = this.$refs.viewer

                viewer && viewer.$viewer.show()
            } else if (item.filetype === 'video') {
                this.playerOptions.video.url = fileUrl;

                this.$msgbox({
                    title: this.title,
                    message: (<VideoDPlayer ref="audio" {...{ props: { options: this.playerOptions } }} key={Date.now()} />),
                    customClass: 'dialog__update-data',
                    confirmButtonText: '关闭',
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            this.$refs.audio.close();
                            done()
                        } else {
                            this.$refs.audio.close();
                            done()
                        }
                    }
                }).then(null, () => { })
            } else if (item.filetype === 'audio') {
                this.$msgbox({
                title: this.title,
                message: (<AudioDPlayer ref="audio" {...{ props: { AudioSrc:fileUrl }  }} key={Date.now()} />),
                customClass: 'dialog__update-data',
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        this.$refs.audio.close();
                        done()
                    } else {
                        this.$refs.audio.close();
                        done()
                    }
                }
            }).then(null, () => { })
            }

        }
    },
    computed: {
        boxWidth() {
            return /^\d+(\.\d+)?$/.test(String(this.width)) ? `${this.width}px` : this.width
        },
        wrapStyle() {
            if (this.gutter > 0) {
                const padding = Math.floor(this.gutter / 2) + 'px'
                return {
                    padding: `0 ${padding} ${padding}`
                }
            }
            return {}
        }
    }
}
</script>

<style lang="scss">
.el-upload-list__item-status-down {
    position: absolute;
    right: 5px;
    top: 0;
    line-height: inherit;
}

.el-upload-list__item-status-down:hover .preview {
    color: red;
}

.el-upload-list__item-status-down:active .preview {
    color: red
}

.el-upload-list__item-status-down:hover .download {
    color: red;
}

.el-upload-list__item-status-down:active .download {
    color: red
}
</style>